import dynamic from "next/dynamic";
import React from "react";
import Image from "next/image";
import Chartreuse from "../../public/Raraity_Primary_Icon_Chartreuse.svg";

const Header = dynamic(() => import("./Header"));

type ContentLayoutProps = {
  children: React.ReactNode;
  title: string;
};

function ContentLayout({ children, title }: ContentLayoutProps) {
  return (
    <>
      <Header title={title} />
      <div
        className="h-[calc(100vh-64px)] w-screen flex justify-center items-center relative overflow-hidden"
        style={{ backgroundColor: "#d29668" }}
      >
        {/* MOBILE Background Design with Chartreuse 'R' Logos */}
        <div className="md:hidden">
          {/* MOBILE Top Right Corner R */}
          <div className="absolute w-[900px] h-[900px] top-0 right-0 transform translate-x-[45em] translate-y-[-50em] ">
            <Image className="" src={Chartreuse} alt="Raraity" />
          </div>
          {/* MOBILE Bottom Right Corner R */}
          <div className="absolute w-[900px] h-[900px] bottom-0 right-0 transform translate-x-[48em] translate-y-[45em]">
            <Image className="rotate-180" src={Chartreuse} alt="Raraity" />
          </div>
          {/* MOBILE Bottom Left Corner R */}
          <div className="absolute w-[900px] h-[900px] bottom-0 left-0 transform translate-x-[-50em] translate-y-[44em]">
            <Image className="rotate-180" src={Chartreuse} alt="Raraity" />
          </div>
          {/* MOBILE Top Right Corner R */}
          <div className="absolute w-[900px] h-[900px] top-0 left-0 transform translate-x-[-50em] translate-y-[-55em]">
            <Image className="" src={Chartreuse} alt="Raraity" />
          </div>
        </div>
        {/* DESKTOP | Background Design with 2 Chartreuse 'R' Logos */}
        <div className="hidden md:block">
          {/* DESKTOP Right R */}
          <div className="absolute w-[200%] h-[200%] left-0 transform translate-x-[25em] translate-y-[-50em]">
            <Image src={Chartreuse} alt="Raraity" />
          </div>
          {/* DESKTOP Left R [this R is rotated 180 degrees] */}
          <div className="absolute w-[200%] h-[200%] left-0 transform translate-x-[-40em] translate-y-[-50em]">
            <Image className="rotate-180" src={Chartreuse} alt="Raraity" />
          </div>
        </div>
        {/* Wave Below Navbar */}
        <div>
          {/* Top wavy SVG */}
          <svg
            className="absolute inset-x-0 top-[-45px] h-1/6 w-screen"
            viewBox="100 0 1000 100"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#FFFFFF"
              d="M0 33C240 90 480 10 720 33C960 57 1200 -20 1440 33V0H0V33Z"
            />

            <path
              fill="#FFFFFF"
              d="M0 50C240 90 480 60 720 50C960 40 1200 90 1440 50V15H0V50Z"
            />
          </svg>
        </div>
        <div className="bg-white h-[80vh] w-[95vw] md:w-[90vw] rounded-xl sm:p-2 md:p-0 md:pt-2 relative translate-y-[1em] overflow-x-hidden overflow-y-auto">
          {children}
        </div>
      </div>
    </>
  );
}

export default ContentLayout;
